import { render, staticRenderFns } from "./FocusedItem.vue?vue&type=template&id=4ed7b508"
import script from "./FocusedItem.vue?vue&type=script&lang=js"
export * from "./FocusedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports